<template>
    <i class="ico-svg-undo">
        <svg v-bind="{ width, height }" viewBox="0 0 34 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.971 6.106h11.015c6.832 0 12.68 4.624 12.68 12.155 0 7.53-5.848 11.739-12.68 11.739H9.971c-1.473 0-2.21-.623-2.21-1.87 0-1.245.737-1.87 2.21-1.873h11.015c5.315 0 9.1-3.174 9.1-8.207 0-5.034-3.785-8.242-9.1-8.242H9.971v6.1L.333 7.825 9.971 0v6.106z" :fill="color" />
        </svg>
    </i>
</template>

<script>
export default {
    name: 'IconUndo',

    props: {
        width: {
            type: Number,
            default: 34,
        },

        height: {
            type: Number,
            default: 20,
        },

        color: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>
